export const BuildInfo = {timestamp:1772555496000}
